import { type FC, useEffect, useRef } from "react";

type HtmlEmailPreviewProps = {
  htmlContent: string;
  className?: string;
};

/**
 * サンドボックス化されたiframeでHTMLメールをプレビューするコンポーネント
 * @param {HtmlEmailPreviewProps} props
 * @return {JSX.Element} HTMLプレビューiframe
 */
export const HtmlEmailPreview: FC<HtmlEmailPreviewProps> = ({
  htmlContent,
  className = "",
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: htmlContentが変わったときにiframeのリサイズを再実行する必要がある
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const handleLoad = () => {
      try {
        const doc = iframe.contentDocument;
        if (doc?.body) {
          iframe.style.height = `${doc.body.scrollHeight + 20}px`;
        }
      } catch {
        iframe.style.height = "600px";
      }
    };

    iframe.addEventListener("load", handleLoad);
    return () => iframe.removeEventListener("load", handleLoad);
  }, [htmlContent]);

  return (
    <iframe
      ref={iframeRef}
      srcDoc={htmlContent}
      sandbox="allow-same-origin"
      title="メールHTMLプレビュー"
      className={`w-full border border-gray-200 rounded ${className}`}
      style={{ minHeight: "200px" }}
    />
  );
};
